import { render } from "./AdminUserList.vue?vue&type=template&id=53f4a1d8"
import script from "./AdminUserList.vue?vue&type=script&lang=js"
export * from "./AdminUserList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__